import {isMobile as detectIsMobile} from 'react-device-detect';
import {toast} from 'react-toastify';

export const MAX_NAME_LEN = 80;
export const MAX_PASSWORD_LEN = 80;
export const MAX_EMAIL_LEN = 254;
export const MIN_PASSWORD_LEN = 6;
export const APPID_REGEX = /[a-f\d]{24}/i;
export const BASE_URL_REGEX = /\/app\/[a-f\d]{24}/i;
export const REDEMPTION_URL_REGEX = /\/redemption\/[a-f\d]{24}/i;
export const EMAIL_REGEXP = /^(")?(?:[^\."])(?:(?:[\.])?(?:[\w\-!#$%&'*+\/=?\^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){2,6}$/; // eslint-disable-line
export const ASSET_TYPE_IMAGE = 'image';
export const ASSET_TYPE_VIDEO = 'video';

export const IMAGES_ACCEPT_MIMES = ['image/jpeg', 'image/png', 'image/gif'];
export const IMAGES_BUCKET = 'https://s3.amazonaws.com/yak.assets/';
export const MAX_FILE_SIZE_IN_MB = 10;
export const MAX_FILE_SIZES = MAX_FILE_SIZE_IN_MB * 1048576;
export const LIST_PAGE_SIZE = 10;

export const AGORA_APP_ID = '7a6470c7260a42a2be71edac18a18b52';
export const AGORA_VIDEO_PROFILE = '240P';
export const AGORA_RTC_MODE = 'live';

export const VIDEO_SERVICE_DEFAULT_WIDTH = 320;
export const VIDEO_SERVICE_DEFAULT_HEIGHT = 240;
export const VIDEO_SERVICE_DEFAULT_FRAMERATE = 10;

export const NOMEDIASOURCE = 'no-source';
export const VOLUME_METER_DELAY = 1000 / 10;
export const GAMEADMINTYPE = 'admin';
export const GAMEAUDIENCETYPE = 'audience';
export const AUDIO_LEVEL_THRESHOLD = 0.01;

export const WBR_MAX_LENGTH = 5;

export const DEFAULT_LABEL_HOSTS = ['test-game.review', 'staging-test-game', 'dev-test-game'];

export const ABLY_EVENT_GAME_UPDATED = 'GAME_UPDATED';
export const ABLY_EVENT_GAME_CREATED = 'GAME_CREATED';
export const ABLY_EVENT_GAME_HAS_STARTED = 'GAME_HAS_STARTED';
export const ABLY_EVENT_GAME_HAS_FINISHED = 'GAME_HAS_FINISHED';
export const ABLY_EVENT_GAME_ROUND_HAS_FINISHED = 'GAME_ROUND_HAS_FINISHED';
export const ABLY_EVENT_GAME_ROUND_HAS_STARTED = 'GAME_ROUND_HAS_STARTED';
export const ABLY_EVENT_GAME_TEAM_POINTS_INCREMENT = 'GAME_TEAM_POINTS_INCREMENT';
export const ABLY_EVENT_GAME_PLAYER_POINTS_INCREMENT = 'GAME_RESPONDENT_POINTS_HAS_BEEN_CHANGED';
export const ABLY_EVENT_GAME_QUESTION_NEXT = 'GAME_QUESTION_NEXT';
export const ABLY_EVENT_GAME_INTERSTITIAL_HAS_STARTED = 'GAME_INTERSTITIAL_HAS_STARTED';
export const ABLY_EVENT_GAME_INTERSTITIAL_HAS_FINISHED = 'GAME_INTERSTITIAL_HAS_FINISHED';

export const ABLY_EVENT_PLAYER_HAS_JOINED = 'GAME_PLAYER_HAS_JOINED';
export const ABLY_EVENT_PLAYER_HAS_LEFT = 'GAME_PLAYER_HAS_LEFT';
export const ABLY_EVENT_PLAYER_ANSWER_HAS_SELECTED = 'GAME_PLAYER_ANSWER_HAS_SELECTED';
export const ABLY_EVENT_PLAYER_ANSWER_HAS_CHECKED = 'GAME_PLAYER_ANSWER_HAS_CHECKED';
export const ABLY_EVENT_PLAYER_HAS_RECONNECTED = 'GAME_PLAYER_HAS_RECONNECTED';
export const ABLY_EVENT_PLAYER_READY = 'GAME_PLAYER_READY';
export const ABLY_GAME_ADMIN_HAS_CHANGED = 'GAME_ADMIN_HAS_CHANGED';

export const ABLY_EVENT_USER_IS_ONLINE = 'GAME_USER_IS_ONLINE';
export const ABLY_EVENT_USER_IS_OFFLINE = 'GAME_USER_IS_OFFLINE';

export const ABLY_EVENT_PLAYER_SEND_GIFT_SUCCESS = 'GAME_GIFT_HAS_BEEN_MADE';
export const ABLY_EVENT_GAME_RESPONDENT_HAS_BEEN_CHANGED = 'GAME_RESPONDENT_HAS_BEEN_CHANGED';

export const ABLY_EVENT_GAME_PLAYER_KICK = 'GAME_PLAYER_KICK';
export const ABLY_EVENT_GAME_PLAYER_KICK_INIT = 'GAME_PLAYER_KICK_INIT';
export const ABLY_EVENT_GAME_PLAYER_KICK_VOTED = 'GAME_PLAYER_KICK_VOTED';
export const ABLY_EVENT_GAME_PLAYER_KICKED = 'GAME_PLAYER_KICKED';

export const ABLY_ERROR = 'ERROR';

export const GAME_PHASE_WAITING_FOR_PLAYERS = 'WAITING_FOR_PLAYERS';
export const GAME_PHASE_PLAYING = 'PLAYING';
export const GAME_PHASE_FINISHED = 'FINISHED';

export const CHAT_EVENT = 'chat-message';

export const payPalSDKClientID = (process.env.NODE_ENV === 'production' && process.env.API_URL !== 'https://apigw.yaknetwork.com/staging')
  ? 'AWfiGnb6HTf7o3ejbvshxDud97ru5x-tFKN1APOqV1SN0QlqyVwGMENJtxDkwtan-djWS_tAW4GQ4VEA'
  : 'AUaD83rD7eg8_DHqcPhlmTb4Pk2xH0vwr08TFGvXJOSUm3XwRKMoEJCNTe4WU9z9EpimHSUPOdZOJ-fh';

export const bugsnagAPIKey = '0c39838ee5e806ea9718a0c46d21d443';

export const isMobile = detectIsMobile
  || /iPad|iPhone|iPod/.test(navigator.platform)
  || (WURFL.is_mobile === true && ['Phone', 'Tablet', 'Smartphone', 'Feature Phone', 'Other Mobile'].includes(WURFL.form_factor))
  || /google_sdk|Emulator|Android SDK buil(d|t) for x86/.test(navigator.userAgent);

export const defaultToastProps = {position: toast.POSITION.TOP_CENTER, autoClose: 10000};

export const MAX_API_RETRIES = 3;
